var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.2562404,10.331 C13.0902404,10.515 13.0002404,10.752 13.0002404,11 L13.0002404,21.382 L10.9992404,20.382 L11.0002404,11 C11.0002404,10.752 10.9082404,10.515 10.7432404,10.331 L3.24524044,2 L20.7542404,2 L13.2562404,10.331 Z M23.9132404,0.593 C23.7522404,0.232 23.3952404,0 23.0002404,0 L1.00024044,0 C0.605240437,0 0.247240437,0.232 0.0862404371,0.593 C-0.0737595629,0.954 -0.00775956291,1.375 0.256240437,1.669 L9.00024044,11.384 L9.00024044,21 C9.00024044,21.379 9.21324044,21.725 9.55324044,21.894 L13.5532404,23.894 C13.8632404,24.05 14.2312404,24.033 14.5262404,23.851 C14.8212404,23.668 15.0002404,23.347 15.0002404,23 L15.0002404,11.384 L23.7432404,1.669 C24.0082404,1.375 24.0742404,0.954 23.9132404,0.593 L23.9132404,0.593 Z",
    id: "path-filter"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PC_ph2.5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "[PC:ph2.5]-Settings---Information",
    transform: "translate(-318.000000, -224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter/FilterItem",
    transform: "translate(310.000000, 214.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter/FilterButton",
    transform: "translate(8.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/common/filter",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-filter",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-filter"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Fill-1",
    fill: "currentColor",
    xlinkHref: "#path-filter"
  }), /*#__PURE__*/React.createElement("g", {
    id: "gray+1",
    mask: "url(#mask-filter)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "color",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.18e9a101e41ac96cfe4d4d5b345664e0.svg";
export { ForwardRef as ReactComponent };